<div class="wrapper">
    <ix-content-header width="100%"
        hasBackButton="false"
        headerTitle="Audit Log"
        headerSubtitle="Lists API actions">
    </ix-content-header>

    <app-crmt-audit-log></app-crmt-audit-log>
</div>  
